<template>
	<div class="animated fadeIn">
		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<b-row>
							<b-col md="6">
								<strong>{{ incident.incidentName }}</strong>
							</b-col>
							<b-col md="6" class="d-flex justify-content-end">
								<div v-if="loading" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
							</b-col>
						</b-row>
					</template>
					<b-card-body>
						<b-row class="mb-4">
							<b-col md="4" lg="4">
								<h6 class="mb-3">Detalles del Cliente:</h6>
								<div>Número de Cuenta: <strong>{{ account.accountNumber }}</strong></div>
								<div><strong>{{ account.accountName }}</strong></div>
								<div><strong>{{ account.alias }}</strong></div>
								<div v-if="account.email">Correo Electrónico: <strong>{{ account.email }}</strong></div>
								<div v-if="account.phone">Teléfono: <strong>{{ account.phone }}</strong></div>
								<div v-if="account.ClientAdvisor">Ejecutivo de Cuenta:
									<strong>{{ account.ClientAdvisor.name }}</strong>
								</div>
								<div v-if="incident.MaintenanceContract">
									Contrato de Mantenimiento: <strong>{{ incident.MaintenanceContract.Name }}</strong>
								</div>
								<div v-if="incident.Contract">
									Contrato de Monitoreo: <strong>{{ incident.Contract.Name }}</strong>
								</div>
							</b-col>
							<b-col md="4" lg="4">
								<h6 class="mb-3">Detalles del Caso</h6>
								<div>
									Seguimiento: <strong>{{ incident.tracking }}</strong>
								</div>
								<div>
									Número de Caso: <strong>{{ incident.incidentNumber }}</strong>
								</div>
								<div>
									Número de Ticket: <strong>{{ incident.ticketID }}</strong>
								</div>
								<div>
									Título del Caso: <strong>{{ incident.incidentName }}</strong>
								</div>
								<div v-if="incident.System">
									Sistema: <strong>{{ incident.System.Name }}</strong>
								</div>
							</b-col>
							<b-col md="12" lg="12" class="mt-3">
								<div class="text-justify">
									<strong class="text-info">Descripción:</strong>
									<br/>
									<strong>{{ incident.description }}</strong>
								</div>
							</b-col>
						</b-row>
						<b-row class="mb-4">
							<h5 class="border-bottom w-100 border-info pb-1">Programación</h5>
							<b-col md="3" lg="3">
								<h6>Posibles Técnicos</h6>
								<div>
									Control de Atención: <strong>{{ incident.attentionControl }}</strong>
								</div>

								<div>
									Fecha de Programación: <strong>{{ incident.programmingDate|dateFormat }}</strong>
								</div>

								<div>
									Fecha Cliente: <strong>{{ incident.clientDate|dateFormat }}</strong>
								</div>
							</b-col>
							<b-col v-if="incident.technical" md="3" lg="3">
								<h6>Técnico #1</h6>
								{{ incident.technical.name }}
								<b-row v-if="incident.technical.photo">
									<b-col md="6" lg="6">
										<b-img :src="incident.technical.photo" thumbnail fluid></b-img>
									</b-col>
								</b-row>
							</b-col>
							<b-col v-if="incident.technical2" md="3" lg="3">
								<h6>Técnico #2</h6>
								{{ incident.technical2.name }}
								<b-row v-if="incident.technical2.photo">
									<b-col md="6" lg="6">
										<b-img :src="incident.technical2.photo" thumbnail fluid></b-img>
									</b-col>
								</b-row>
							</b-col>
							<b-col v-if="incident.technical3" md="3" lg="3">
								<h6>Técnico #3</h6>
								{{ incident.technical3.name }}
								<b-row v-if="incident.technical3.photo">
									<b-col md="6" lg="6">
										<b-img :src="incident.technical3.photo" thumbnail fluid></b-img>
									</b-col>
								</b-row>
							</b-col>
						</b-row>
					</b-card-body>
				</b-card>

				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-services
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Boletas de Servicio</strong>
								<div v-if="serviceTicketTicketLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!serviceTicketTicketLoader" class="when-closed fa fa-plus-circle"
								   aria-hidden="true"></i>
								<i v-if="!serviceTicketTicketLoader" class="when-opened fa fa-minus-circle"
								   aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-services">
						<b-card-body class="table-responsive">
							<b-table :items="serviceTickets"
									 :fields="tableFields"
									 :busy="serviceTicketTicketLoader"
									 show-empty
									 striped
									 empty-filtered-text="No hay boletas de servicio disponibles"
									 empty-text="No hay boletas de servicio disponibles"
									 head-variant="light">
								<div slot="CreatedOn" slot-scope="item">
									{{ item.item.CreatedOn | dateFormatFull }}
								</div>

								<div slot="CheckIn" slot-scope="item">
									{{ item.item.CheckIn | dateFormatFull }}
								</div>

								<div slot="CheckOut" slot-scope="item">
									{{ item.item.CheckOut | dateFormatFull }}
								</div>

								<div slot="detail" slot-scope="item">
									<router-link :to="{name: 'ServiceTicketDetail', params: {id: item.item.Id}}">
										Ver
									</router-link>
								</div>

								<template v-slot:table-busy>
									<div class="text-center text-info my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>
								</template>
							</b-table>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-invoices
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Facturas</strong>
								<div v-if="invoicesLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!invoicesLoader" class="when-closed fa fa-plus-circle" aria-hidden="true"></i>
								<i v-if="!invoicesLoader" class="when-opened fa fa-minus-circle" aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-invoices">
						<b-card-body class="table-responsive">
							<invoice-table-component v-bind:invoices-list="invoices" v-bind:loader="invoicesLoader"/>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<b-row class="justify-content-center">
			<b-col md="12" lg="12">
				<b-card>
					<template v-slot:header>
						<div role="tab">
							<b-link href="#" v-b-toggle.collapse-travel-expenses
									class="text-primary d-flex justify-content-between text-decoration-none align-items-center">
								<strong>Viáticos</strong>
								<div v-if="travelExpensesLoader" class="ml-2">
									<b-spinner variant="primary" label="Spinning" small>
									</b-spinner>
								</div>
								<i v-if="!travelExpensesLoader" class="when-closed fa fa-plus-circle"
								   aria-hidden="true"></i>
								<i v-if="!travelExpensesLoader" class="when-opened fa fa-minus-circle"
								   aria-hidden="true"></i>
							</b-link>
						</div>
					</template>
					<b-collapse id="collapse-travel-expenses">
						<b-card-body class="table-responsive">
							<b-table :items="travelExpenses"
									 :fields="travelExpensesTableFields"
									 :busy="travelExpensesLoader"
									 show-empty
									 striped
									 empty-filtered-text="No hay viáticos disponibles"
									 empty-text="No hay viáticos disponibles"
									 head-variant="light">
								<div slot="CreatedOn" slot-scope="item">
									{{ item.item.CreatedOn | dateFormatFull }}
								</div>

								<div slot="TotalUSD" slot-scope="item">
									{{
										item.item.TotalUSD | currency(
											configSymbolUSD, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}
								</div>

								<!--<div slot="TotalCRC" slot-scope="item">
									{{
										item.item.TotalCRC | currency(
											configSymbolCRC, configSeparator, configFractionCount,configFractionSeparator, configSymbolPosition, configSymbolSpacing
											)
									}}
								</div>-->

								<div slot="detail" slot-scope="item">
									<router-link :to="{name: 'TravelExpenseDetail', params: {id: item.item.Id}}">
										Ver
									</router-link>
								</div>

								<template v-slot:table-busy>
									<div class="text-center text-info my-2">
										<b-spinner class="align-middle"></b-spinner>
									</div>
								</template>
							</b-table>
						</b-card-body>
					</b-collapse>
				</b-card>
			</b-col>
		</b-row>

		<GoBackComponent></GoBackComponent>
	</div>
</template>

<script>
import GoBackComponent from "../components/GoBackComponent";
import {mapActions, mapState} from "vuex";
import InvoiceTableComponent from "../components/InvoiceTableComponent";

export default {
	name: "IncidentDetail",
	components: {
		GoBackComponent,
		InvoiceTableComponent
	},
	data: function () {
		return {
			loading: false,
			invoicesLoader: false,
			serviceTicketTicketLoader: false,
			travelExpensesLoader: false,
			incident: {},
			account: {},
			invoices: [],
			travelExpenses: [],
			tableFields: {
				Number: {
					label: '# Boleta'
				},
				CreatedOn: {
					label: "Fecha de Creación"
				},
				CheckIn: {
					label: 'Entrada'
				},
				CheckOut: {
					label: 'Salida'
				},
				TotalTime: {
					label: 'Tiempo Total'
				},
				detail: {
					label: 'Detalles'
				}
			},
			travelExpensesTableFields: {
				Name: {
					label: 'Número'
				},
				TotalUSD: {
					label: 'Total $'
				},
				CreatedOn: {
					label: 'F. Creación'
				},
				OpportunityNumber: {
					label: '#Valoración'
				},
				Opportunity: {
					label: 'Valoración'
				},
				detail: {
					label: 'Detalles'
				}
			},
			configSeparator: '.',
			configFractionCount: 2,
			configFractionSeparator: ',',
			configSymbolPosition: 'front',
			configSymbolSpacing: false,
			configSymbolUSD: '$',
			configSymbolCRC: '₡',
		}
	},
	mounted() {
		this.loading = true;
		this.invoicesLoader = true;
		this.serviceTicketTicketLoader = true;
		this.travelExpensesLoader = true;
		this.account = this.$store.state.accountSelected;

		const incidentID = this.$route.params.id;

		this.$store.dispatch('getIncidentDetail', incidentID)
			.then((incident) => {
				this.incident = incident;

				this.getServiceTickets(incidentID)
					.finally(() => {
						this.serviceTicketTicketLoader = false;
					})

				this.getIncidentInvoices(incidentID)
					.then((invoices) => {
						this.invoices = invoices;
					})
					.catch((err) => {
						this.invoicesLoader = false;
						console.log(err);
					})
					.finally(() => {
						this.invoicesLoader = false;
					})

				this.getTravelExpenses(incidentID)
					.then((travelExpenses) => {
						console.log(travelExpenses)
						this.travelExpenses = travelExpenses;
					})
					.catch((err) => {
						this.travelExpensesLoader = false;
						console.error(err);
					})
					.finally(() => {
						this.travelExpensesLoader = false;
					})

			})
			.finally(() => {
				this.loading = false;
			});
	},
	methods: {
		...mapActions([
			'getIncidentInvoices',
			'getServiceTickets',
			'getTravelExpenses'
		])
	},
	computed: {
		...mapState({
			serviceTickets: state => state.serviceTickets
		})
	}
}
</script>

<style scoped>

</style>
